import * as React from 'react';

function SvgHotels(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28.265 22.422" {...props}>
      <g data-name="Component 2 \u2013 1" fill="none">
        <path
          data-name="Path 412"
          d="M26.438 8.29h-.024a1.33 1.33 0 00-1.327 1.327.135.135 0 01-.134.134H3.312a.135.135 0 01-.134-.134A1.33 1.33 0 001.85 8.29h-.023A1.33 1.33 0 00.5 9.617v10.979a1.33 1.33 0 001.327 1.327h.023a1.33 1.33 0 001.327-1.327v-.377a.244.244 0 01.243-.243h21.424a.244.244 0 01.243.243v.377a1.33 1.33 0 001.327 1.327h.024a1.33 1.33 0 001.327-1.327V9.617a1.33 1.33 0 00-1.327-1.327z"
        />
        <path
          data-name="Path 413"
          d="M3.665 8.655h1.369a.244.244 0 00.243-.243v-.791a.977.977 0 01.974-.974h5.934a.977.977 0 01.974.974v.791a.244.244 0 00.243.243h1.461a.244.244 0 00.243-.243v-.791a.977.977 0 01.974-.974h5.934a.977.977 0 01.974.974v.791a.244.244 0 00.243.243H24.6a.488.488 0 00.487-.487V2.447A1.953 1.953 0 0023.14.5H5.125a1.953 1.953 0 00-1.947 1.947v5.721a.488.488 0 00.487.487z"
        />
      </g>
    </svg>
  );
}

export default SvgHotels;
